import { cn } from '@/lib/utils';
import { MATRIX_PIVOT_LABELS, type MatrixPivot } from '@mss_creator/shared';

export interface PivotPillProps {
  pivot: MatrixPivot;
}

/**
 * One noyau per pivot, on the dot only (planche 03, retained variant): the
 * text stays neutral so the pill is never mistaken for a state badge, whose
 * colour already means something. The label is what counts; the dot is a
 * weak cue, never the only one.
 */
const PIVOT_DOT_CLASSES: Readonly<Record<MatrixPivot, string>> = {
  driver: 'bg-bleu-ciel',
  levier_implication: 'bg-vert',
  principe_action: 'bg-jaune',
  levier_valeur: 'bg-rose',
};

/** The pivot of a matrix: a neutral pill with a coloured dot. */
export function PivotPill({ pivot }: PivotPillProps) {
  return (
    <span
      data-pivot={pivot}
      className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-gray-200 bg-white px-2 py-0 font-semibold text-caption text-gray-700 leading-normal"
    >
      <span
        aria-hidden="true"
        className={cn('size-2 shrink-0 rounded-full', PIVOT_DOT_CLASSES[pivot])}
      />
      {MATRIX_PIVOT_LABELS[pivot]}
    </span>
  );
}
